import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-18337140"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "navbar-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "EasyBank logo"
  })
], -1))
const _hoisted_3 = { class: "navbar-links" }
const _hoisted_4 = { class: "navbar-button" }
const _hoisted_5 = { class: "navbar-list" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "show"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ButtonRequest = _resolveComponent("ButtonRequest")!
  const _component_menu_hamburguer = _resolveComponent("menu-hamburguer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Button, {
        text: "Home",
        buttonType: "button-header"
      }),
      _createVNode(_component_Button, {
        text: "About",
        buttonType: "button-header"
      }),
      _createVNode(_component_Button, {
        text: "Contact",
        buttonType: "button-header"
      }),
      _createVNode(_component_Button, {
        text: "Blog",
        buttonType: "button-header"
      }),
      _createVNode(_component_Button, {
        text: "Carrers",
        buttonType: "button-header"
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_ButtonRequest, { text: "Request Invite" })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("img", {
        src: _ctx.icon.toString(),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeIcon && _ctx.changeIcon(...args))),
        alt: "Icon"
      }, null, 8, _hoisted_6)
    ]),
    (_ctx.hamb)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_menu_hamburguer)
        ]))
      : _createCommentVNode("", true)
  ]))
}